import { Body2 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './NewbuildingHeaderCompareButton.css';

export function CompareOnboardingContent() {
  return (
    <div className={styles['onboarding-content']}>
      <Body2 color="text-inverted-default">Сравнивайте интересные ЖК, чтобы{NBSP}выбрать лучший</Body2>
    </div>
  );
}
